export default __webpack_public_path__ + "static/media/Logo_Beehaz.1077188d.png";